import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a8c5daac&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&module=true&lang=css&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./index.vue?vue&type=style&index=0&module=true&lang=css&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./index.vue?vue&type=style&index=0&module=true&lang=css&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("C:\\JH\\workspace\\r-UXDB4MFGGPNCQDCDVDHZHNGFNLKBT4K2FS26AFERI7RXVKAFNI2A\\node_modules\\vue-hot-reload-api\\dist\\index.js").rerender("a8c5daac")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\JH\\workspace\\r-UXDB4MFGGPNCQDCDVDHZHNGFNLKBT4K2FS26AFERI7RXVKAFNI2A\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8c5daac')) {
      api.createRecord('a8c5daac', component.options)
    } else {
      api.reload('a8c5daac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a8c5daac&", function () {
      api.rerender('a8c5daac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "sources/common/Scrollbar/index.vue"
export default component.exports